// extracted by mini-css-extract-plugin
module.exports = {"settings":"_0fe4e33","layout":"_effe59c","setting":"_bc93154","heading":"_c58069b","subheading":"_6d42f9a"};